import { ENV } from './environment'

function getRequirePhoneNumber(): string {
  if (ENV === 'prod') {
    return 'itp-112_dtc_census_require_phone_number'
  } else {
    return 'itp-009_test-legacy'
  }
}
export const REQUIRE_PHONE_NUMBER = getRequirePhoneNumber()

export const PPI_243_ESIG_AGENTS = 'ppi-243_esig_agents' as const
export const PPI_243_ESIG_AGENTS_VARIANTS = {
  CONTROL: 'control',
  ESIG_ENABLED: 'esig-enabled'
} as const

export const PPI_472_ESIG_AGENTS = 'ppi-472_esig_agents' as const
export const PPI_472_ESIG_AGENTS_VARIANTS = {
  CONTROL: 'control',
  ESIG_ENABLED: 'esig-enabled'
} as const

export const PPI_330_ADDITIONAL_PRODUCTS_TAB = 'ppi-330_additional_products_tab'
export const PPI_330_ADDITIONAL_PRODUCTS_TAB_VARIANTS = {
  CONTROL: 'control',
  ADDITIONAL_PRODUCTS_TAB: 'additional_products_tab'
}

function getHideDTCFunnelPopups(): string {
  if (ENV === 'prod') {
    return 'itp-228_dtc_funnel_popups_prod'
  } else {
    return 'itp-167_dtc_funnel_popups_dev'
  }
}

export const HIDE_DTC_FUNNEL_POPUPS = getHideDTCFunnelPopups()
export const HIDE_DTC_FUNNEL_POPUPS_VARIANTS = {
  CONTROL: 'control',
  TREATMENT: 'treatment'
} as const

export const PPI_537_SKIP_QUOTES_PAGE = 'ppi-537_skip_quotes_page'
export const PPI_537_SKIP_QUOTES_PAGE_VARIANTS = {
  CONTROL: 'control',
  SKIP_QUOTES_PAGE: 'treatment'
}
